import { graphql } from '../gql'

export const GET_PRODUCTS_BADGES_QUERY = graphql(`
  query GetProductsBadges($ids: [String!]!) {
    products(options: { filter: { id: { in: $ids } } }) {
      items {
        id
        variantList {
          items {
            customFields {
              is_best_seller
              is_featured
              date_featured_start
              date_featured_end
              is_discontinued
              is_new
              is_promotion
              promotion_date_start
              promotion_date_end
              minQuantity
            }
            price
            priceWithTax
            prices {
              price
              priceWithTax
              customFields {
                quantityPriceTiers {
                  quantityStart
                  price
                }
              }
            }
          }
        }
      }
    }
  }
`)
